module.exports = __webpack_public_path__ + "da10bc78123fcb062925476e878d3f89.svg";


//////////////////
// WEBPACK FOOTER
// ./images/current-location-marker.svg
// module id = 38
// module chunks = 0